import React from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import compose from 'recompose/compose';
import iconOrange from '../marker-icon-orange.png';
import iconBlue from '../marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { GET_LIST, withDataProvider } from 'react-admin';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';

const style = {
    height: '500px',
    marginTop: '20px',
};

const LeafIcon = L.Icon.extend({
    options: {
        iconSize:     [25, 41],
        shadowSize:   [41, 41],
        iconAnchor:   [12, 41],
        shadowAnchor: [12, 41],
        popupAnchor:  [-3, -76]
    }
});

const blueIcon = new LeafIcon({
    iconUrl: iconBlue,
    shadowUrl: iconShadow
});

const orangeIcon = new LeafIcon({
    iconUrl: iconOrange,
    shadowUrl: iconShadow
});

class Map extends React.Component {

    constructor(props) {
        super(props);
        this.state = {markers: [], autoRefresh: false, selectedDevice: ''};
    }

    async getDeviceMarkers() {
        const { dataProvider } = this.props;
        const {data: devices} = await dataProvider(
            GET_LIST,
            'devices',
            {
                pagination: {
                    page: 1, perPage: 100
                },
                sort: {
                    field: 'id',
                    order: 1
                }
            }
        );

        let markers = [];
        const deviceList = devices;
        if(deviceList) {
            markers = deviceList.filter(item => {
                return item.x !== "None" && item.y !== "None";
            }).map(item => {
                return {
                    latLng: {lat: item.y, lng: item.x},
                    label: item.vehicle,
                    title: item.vehicle,
                    selected: item.id === this.state.selectedDevice,
                }
            });
        }
        this.updateMarkers(markers);
        //this.setState({markers});
    }

    componentDidMount() {
        this.map = L.map('map', {
            center: [60.313, 24.97],
            zoom: 13,
            layers: [
                L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                }),
            ]
        });
        this.layer = L.layerGroup().addTo(this.map);

        this.getDeviceMarkers().then(() => {});
    }

    componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.selectedDevice !== this.props.selectedDevice) {
            this.setState({
                selectedDevice: this.props.selectedDevice
            });
            this.getDeviceMarkers().then(() => {});
        }
    }

    updateMarkers(markersData) {
        this.layer.clearLayers();
        markersData.forEach(marker => {
            L.marker(
                marker.latLng,
                {
                    title: marker.title,
                    icon: marker.selected ? orangeIcon : blueIcon,
                    autoPan: marker.selected,
                    zIndexOffset: marker.selected ? 10000 : 999
                }
            ).addTo(this.layer);
        });
    }

    handleRefresh(checked) {
        if (checked) {
            const interval = setInterval(() => this.getDeviceMarkers(), 3000);
            this.setState({interval: interval});
        } else {
            clearInterval(this.state.interval);
        }
    }

    render() {
        return (
        <div>
            <FormControlLabel
                control={
                    <Switch
                        onChange={e => this.handleRefresh(e.target.checked)}
                        color="primary"
                    />
                }
                label="Auto refresh"
            />
            <div id="map" style={style}></div>
        </div>
        );
    }
}

export default compose(
    withDataProvider
)(Map);
